import { z } from 'zod';
import { IsoTimestampSchema, MontoClpSchema, UlidSchema } from './common.js';

export const TipoMovimientoFondoSchema = z.enum(['ingreso', 'egreso']);
export type TipoMovimientoFondo = z.infer<typeof TipoMovimientoFondoSchema>;

export const CategoriaMovimientoFondoSchema = z.enum([
  'auto_asignacion',
  'aporte_extraordinario',
  'gasto_autorizado',
  'reversion_anulacion',
]);
export type CategoriaMovimientoFondo = z.infer<typeof CategoriaMovimientoFondoSchema>;

export const MovimientoFondoSchema = z.object({
  id: UlidSchema,
  tenantId: UlidSchema,
  tipo: TipoMovimientoFondoSchema,
  categoria: CategoriaMovimientoFondoSchema,
  monto: MontoClpSchema,
  descripcion: z.string().min(3).max(500),
  saldoAnterior: z.number().int().min(0),
  saldoNuevo: z.number().int().min(0),
  hashAnterior: z.string().length(64),
  hash: z.string().length(64),
  referenciaId: UlidSchema.optional(),
  creadoPor: z.string().min(1),
  creadoEn: IsoTimestampSchema,
});
export type MovimientoFondo = z.infer<typeof MovimientoFondoSchema>;

export const RegistrarIngresoFondoRequestSchema = z.object({
  monto: MontoClpSchema,
  descripcion: z.string().min(3).max(500),
  categoria: CategoriaMovimientoFondoSchema.exclude(['auto_asignacion', 'reversion_anulacion']).default('aporte_extraordinario'),
});
export type RegistrarIngresoFondoRequest = z.infer<typeof RegistrarIngresoFondoRequestSchema>;

export const RegistrarEgresoFondoRequestSchema = z.object({
  monto: MontoClpSchema,
  descripcion: z.string().min(3).max(500),
});
export type RegistrarEgresoFondoRequest = z.infer<typeof RegistrarEgresoFondoRequestSchema>;

export const FondoResumenSchema = z.object({
  saldoActual: z.number().int().min(0),
  ultimoMovimiento: MovimientoFondoSchema.nullable(),
});
export type FondoResumen = z.infer<typeof FondoResumenSchema>;

export const ListarMovimientosFondoResponseSchema = z.object({
  items: z.array(MovimientoFondoSchema),
  cursor: z.string().nullable(),
});
export type ListarMovimientosFondoResponse = z.infer<typeof ListarMovimientosFondoResponseSchema>;
